import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {AccessControlService} from '../../../../../services/access-control.service';
import {BpAdministrationService} from '../../../../../services/bp-administration.service';

@Component({
  selector: 'app-queue-action-modal',
  templateUrl: './queue-action-modal.component.html',
  styleUrls: ['./queue-action-modal.component.css']
})
export class QueueActionModalComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState;

  queueActionForm: FormGroup;

  messageError;
  messageSuccess;
  submitClick = false;
  loadingList = false;

  availableUsers;
  selectedInstances: number[];
  selectedStateIds: number[];
  hasUsers;
  isCustom = false;

  itemSaved: Subject<boolean> = new Subject<boolean>();

  get formData() {
    return this.queueActionForm.controls;
  }
  constructor(private formBuilder: FormBuilder, public bsModalRef: BsModalRef, private accessControlService: AccessControlService,
              private bpAdminService: BpAdministrationService) { }

  ngOnInit() {
    this.createForm();
    if (this.objInitialState){
      this.isCustom = this.objInitialState.isCustom;
      this.selectedInstances = this.objInitialState.checkedInstances;
      this.selectedStateIds = this.objInitialState.checkedInstancesStatesId;
      let customQueues = null;
      if (this.objInitialState.customQueues) {
        customQueues = this.objInitialState.customQueues;
      }
      this.loadUsers(this.objInitialState.checkedInstancesStatesId, customQueues);
    }
  }

  createForm() {
    this.queueActionForm = this.formBuilder.group({
      action: 'unlock',
      removeDrafts: false,
      userId: null
    })
  }

  loadUsers(statesId, customQueues = null) {
    this.messageError = '';
    const permissionName = 'Interagir';
    this.loadingList = true;
    if (!this.isCustom) {
      this.accessControlService.getUsersWithEffectivePermissionOnState(statesId, permissionName).subscribe(result => {
        this.setUsersResult(result);
      }, error1 => {
        this.messageError = this.getMessageError(error1);
        this.loadingList = false;
      })
    } else {
      this.accessControlService.getUsersPermissionOnStateAndCustomQueues(statesId, permissionName, customQueues).subscribe(result => {
        this.setUsersResult(result);
      }, error1 => {
        this.messageError = this.getMessageError(error1);
        this.loadingList = false;
      });
    }
  }

  setUsersResult(result) {
    this.loadingList = false;
    this.availableUsers = result;
    this.hasUsers = result.length > 0;
  }

  getMessageError(error) {
    let err = error;
    if (error.indexOf('401') !== -1) {
      err = 'Erro: Sessão expirada.';
    }
    return err;
  }

  onSave() {
    this.messageError = '';
    this.messageSuccess = '';
    this.submitClick = true;

    const values = this.queueActionForm.getRawValue();
    values.instanceIds = this.selectedInstances;
    let params: any = {
      instanceIds: this.selectedInstances,
      removeDrafts: this.isCustom ? !values.removeDrafts : values.removeDrafts
    };

    if (values.action == 'lock') {
      params.userId = values.userId;

      this.bpAdminService.transferBusinessProcessInstanceLocks(params).subscribe(result => {
        this.messageSuccess = 'Instância(s) alocada(s) para o usuário selecionado.';
        this.submitClick = false;
        setTimeout(() => {
          this.messageSuccess = '';
          this.itemSaved.next(true);
          this.bsModalRef.hide();
        }, 1500);
      }, error1 => {
        let err = error1;
        if (error1.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.messageError = err;
        setTimeout(() => {
          this.messageError = '';
        }, 1500);
      });
    } else {
      this.bpAdminService.unlockBusinessProcessInstances(params).subscribe(result => {
        this.messageSuccess = 'Instância(s) desalocada(s) com sucesso.';
        this.submitClick = false;
        setTimeout(() => {
          this.messageSuccess = '';
          this.itemSaved.next(true);
          this.bsModalRef.hide();
        }, 1500);
      }, error1 => this.messageError = error1);
    }

  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  onActionChange() {
    if (this.formData.action.value == 'lock') {
      this.queueActionForm.get('userId').setValidators([ Validators.required ]);
    } else {
      this.queueActionForm.get('userId').clearValidators();
      this.queueActionForm.get('userId').setValue(null);
    }
    this.queueActionForm.updateValueAndValidity();
  }

}
